export const chartMargin = { top: 10 };
export const chartBarColor = '#1976d2';
export const chartBarSize = { daily: 30, monthly: 36, yearly: 36, weekly: 32 };
export const chartGridStyle = { strokeDasharray: "3 3" };
export const tooltipPaperStyle = {
  background: "#fff",
  border: "1px solid #1976d2",
  padding: 10,
  borderRadius: 8,
  color: "#1976d2",
  fontWeight: 500
};